<div class="fabs">
  <noxo-demo-tools />
  <button
    type="button"
    noxo-button
    size="s"
    class="fab"
    (click)="open()">
    <noxo-icon icon="circle-nodes" />
    Demo map
  </button>
</div>
<dialog
  noxo-dialog
  placement="side"
  aria-labelledby="demo-map-title">
  <noxo-dialog-header>
    <hgroup>
      <h2 id="demo-map-title">Demo map</h2>
      <p>Jump to any journey — nothing is blocked.</p>
    </hgroup>
    <button
      type="button"
      noxo-icon-button
      shape="round"
      aria-label="Close"
      (click)="close()">
      <noxo-icon icon="xmark" />
    </button>
  </noxo-dialog-header>
  @if (notice(); as message) {
    <noxo-message
      [type]="message.type"
      banner
      >{{ message.text }}</noxo-message
    >
  }
  <section>
    <noxo-card-overline>Persona · sign in as</noxo-card-overline>
    <noxo-demo-persona-list
      [personas]="personas()"
      [signedInAs]="signedInAs()"
      [busy]="busy()"
      (picked)="pick($event)" />
  </section>
  <section>
    <noxo-card-overline>Journeys</noxo-card-overline>
    <noxo-demo-journey-list
      [journeys]="journeys"
      [busy]="busy()"
      (picked)="go($event)" />
  </section>
  <section>
    <noxo-card-overline>More screens</noxo-card-overline>
    <noxo-demo-journey-list
      [journeys]="screens"
      [busy]="busy()"
      (picked)="go($event)" />
  </section>
  <noxo-demo-installations />
  <footer>
    <button
      type="button"
      noxo-list-row
      variant="outline"
      [disabled]="busy()"
      (click)="pick(admin)">
      <noxo-icon icon="user-group" />
      <noxo-list-row-title>Open the admin app</noxo-list-row-title>
      <noxo-icon
        icon="arrow-up-right-from-square"
        trailing />
    </button>
    <button
      type="button"
      noxo-button="tertiary"
      size="xs"
      [disabled]="busy()"
      (click)="reset()">
      Reset the demo
    </button>
  </footer>
  <p class="hint"
    >Dev only: e-mails and SMS land in the inbox above instead of being sent; seed accounts and password from
    `@arya/shared/dev-accounts`; removed from staging and production builds.</p
  >
</dialog>
